import { getDefaultClient } from '@dynamic-labs-sdk/client';
import { assertDefined } from '@dynamic-labs-sdk/client/core';

/**
 * Checks if Solana gas sponsorship is enabled for the current project.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if Solana gas sponsorship is enabled, false otherwise.
 */
export const isSolanaGasSponsorshipEnabled = (
  client = getDefaultClient()
): boolean => {
  assertDefined(client.projectSettings, 'Project settings are not defined');

  return (
    client.projectSettings.sdk.embeddedWallets?.svmGasSponsorshipEnabled ??
    false
  );
};
